/**
 * server封装，所有请求都走这里
 * option = {
 *      url:请求地址
 *      method: 'post' // 请求方式，post\get\put\delete
 *      data: {}, // 参数
 * }
 * service(option)
            .then(data => {
                console.log('then', data);
            })
            .catch(data => {
                console.log('catch', data);
            });
 */

import axios from 'axios';
import config from '@/config/index.js';
const qs = require('querystring');

/**
    * 替换模块url中 {XXX}, 需要参数携带
    * @param {*} url
    * @param {*} param
*/
const parameterTemplate = (url, param) => {
    if (
        _.isObject(param) &&
        typeof param === 'object' &&
        /{([\s\S]+?)}/g.test(url)
    ) {
        url = _.template(url, { interpolate: /{([\s\S]+?)}/g })(param);
    }
    // ssr 请求需要
    url = (param.host ? param.host : '') + url;
    console.log(`parameterTemplate: ${url} ${JSON.stringify(param)}`);
    return url;
};

const service = (option, serverHost = config.serverHost) => {
    const {
        data: originalData = {},
        method,
        contentType = 'application/json',
        mergeData = {},
        requstTypeJson,
        requstTypeFormData,
        headers = {}
    } = option;

    let url = (option.serverHost || serverHost) + option.url;
    config.whitelist.forEach(item => {
        if (option.url.indexOf(item) !== -1) {
            url = option.url;
        }
    });
    url = parameterTemplate(url, originalData);
    const req = {
        method,
        url,
        headers: {
            'Content-Type': contentType,
            ...headers
        }
    };
    const data = { ...mergeData };
    for (const key in originalData) {
        if (
            originalData[key] !== '' &&
            originalData[key] !== null &&
            originalData[key] !== undefined &&
            key !== 'headers'
        ) {
            data[key] = originalData[key];
        }
    }
    if (method === 'post') {
        //针对参数类型是对象（包含数组）
        req.data = requstTypeJson ? data : qs.stringify(data);
        if (requstTypeFormData) {
            const datas = new window.FormData();
            Object.keys(data).forEach(key => {
                datas.append(key, originalData[key]);
            });
            req.data = datas;
        }
    } else {
        req.params = data;
    }
    return axios(req)
        .then(res => {
            return res.data;
        })
        .catch(res => {
            throw res;
        });
};
export default service;



// WEBPACK FOOTER //
// ./src/service/service.js